<template>
  <div class="con font0 text_left">
    <van-sku
      v-model="show"
      :sku="skuTree"
      :goods="goods"
      :hide-quota-text="true"
      :hide-stock="true"
      :initial-sku="initialSku"
      :preview-on-click-image="false"
    >
      <template #sku-stepper="props">
        <div
          v-if="props.selectedSkuComb && props.selectedSkuComb.stock_num <= 10"
          class="font12 font_weight400 colof00 lasted_num"
        >
          仅剩{{
            props.selectedSkuComb ? props.selectedSkuComb.stock_num : 0
          }}件
        </div>
      </template>
      <template #sku-actions="props">
        <div class="sku_btn">
          <div
            class="bottom_btn1 font14 font_weight500 line_height_20 colof text_center"
          >
            <div class="btn text_center" @click="sureGift(props)">
              确定
            </div>
          </div>
        </div>
      </template>
    </van-sku>
  </div>
</template>
<script>
export default {
  props: {
    gitCheckIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      value: 1,
      show: true,
      goods: {
        // 默认商品 sku 缩略图
        picture: "https://assets-img.myazstore.com/freshmilk/xiannai.jpg"
      }
    };
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    },
    skuTree() {
      const { gift } = this.$store.getters.mallretailspu;
      const skuTree = {
        tree: [
          {
            k: "规格",
            k_s: "spec",
            v: []
          }
        ], //sku列表
        list: [] //sku组合
      };
      // gift.spus.forEach(item => {
      const { skus } = gift.spus[this.gitCheckIndex];
      for (let sku in skus) {
        skuTree.tree[0].v.push({ id: sku, name: skus[sku].name });
        const item = {
          id: skus[sku].id, // skuId
          stock_num: skus[sku].stock, // 当前 sku 组合对应的库存
          picture: skus[sku].thumbnailImg,
          spec: sku,
          price: 0
        };
        skuTree.list.push(item);
      }
      // });
      return skuTree;
    },
    initialSku() {
      const { gift } = this.$store.getters.mallretailspu;
      const { spus } = gift;
      const { skus } = spus[0];
      const idName = Object.keys(skus)[0];
      const initialSku = {
        // 键：skuKeyStr（sku 组合列表中当前类目对应的 key 值）
        // 值：skuValueId（规格值 id）
        spec: idName,
        // 初始选中数量
        selectedNum: 1,
        // 初始选中的商品属性
        // 键：属性id
        // 值：属性值id列表
        selectedProp: {
          idName: [idName]
        }
      };
      return initialSku;
    }
    // goodsPic() {
    //   const { skus } = this.$store.getters.mallretailspu;
    //   const goodsPic = {
    //     picture: ""
    //   };
    //   for (let list in skus) {
    //     goodsPic.picture = skus[list].attributeImg;
    //   }
    //   console.log(goodsPic);
    //   return goodsPic;
    // }
  },
  watch: {
    show(nVal, oVal) {
      this.show = true;
      this.$emit("closeSheet");
      console.log(nVal, oVal);
    }
  },
  mounted() {
    this.goods.picture = this.mallretailspu.gift.spus[0].thumbnailImg;
  },
  methods: {
    sureGift(value) {
      this.show = true;
      // eslint-disable-next-line no-unused-vars
      let aa = "";
      for (let ss in value.selectedSku) {
        aa = value.selectedSku[ss];
      }
      for (let sku in this.mallretailspu.gift.spus[0].skus) {
        if (this.mallretailspu.gift.spus[0].skus[sku].name === aa) {
          this.goods.picture = this.mallretailspu.gift.spus[0].skus[
            sku
          ].attributeImg;
        }
      }

      this.$emit("closeSheet");
      // console.log(value, "value");
      this.$emit("sureGift", value);
    }
  }
};
</script>

<style lang="less" scoped>
.example-3d {
  width: 100%;
  // height: 400px;
}

.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 300px;
    text-align: center;
    font-weight: bold;
    font-size: 12px;
    background-color: #2c8dfb;
    background-position: center;
    background-size: cover;
    color: #fff;
  }

  .swiper-pagination {
    ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: #fff;
    }
  }
}
.con {
  ::v-deep .van-sku-row__item--active {
    color: #bf9264;
  }
  .content {
    background: #fff;
    height: 256px;
    .sku_name {
      margin: 0 12px;
      padding: 12px 0 16px;
      .sku_tags {
        margin-top: 12px;
        display: inline-block;
      }
      .name_name {
        margin-top: 4px;
      }
    }
    .sku_over {
      height: 260px;
      overflow-y: scroll;
    }
    .sku_sku_list {
      margin: 0 12px;
      padding: 12px 0;
      .sku_flex {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .sku_item {
          padding: 6px 8px;
          border-radius: 2px;
          border: 1px solid #000;
          margin: 12px 8px 0 0;
        }
      }
    }
    .sku_num {
      margin: 24px 12px 0;
      display: flex;
      .mr_right {
        margin-right: 24px;
      }
    }
  }
  .bottom_btn {
    background: #fff;
    margin: 0 12px;
    padding-bottom: 7px;
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .add_car {
      border-radius: 21px;
      border: 1px solid #000;
      padding: 11px 52px;
    }
    .none_add {
      border-radius: 21px;
      border: 1px solid rgba(0, 0, 0, 0.25);
      padding: 11px 52px;
      background: rgba(0, 0, 0, 0.25);
      border-radius: 21px;
      color: #fff;
    }
    .go_now {
      background: linear-gradient(90deg, #e8caa1 0%, #bf9264 100%);
      border-radius: 21px;
      padding: 12px 52px;
    }
  }
  .bottom_btn1 {
    background: #fff;
    padding-bottom: 7px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .btn {
      border-radius: 21px;
      background: linear-gradient(90deg, #e8caa1 0%, #bf9264 100%);
      padding: 12px 0;
      margin: 0 12px;
    }
  }
  ::v-deep .van-action-sheet {
    max-height: 100%;
  }
  ::v-deep .van-popup--bottom {
    // top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
  }
  ::v-deep .van-stepper__plus {
    background-color: #fff;
  }
  ::v-deep .van-stepper__minus {
    background-color: #fff;
  }
  ::v-deep .van-sku-messages {
    padding-bottom: 60px;
  }
  ::v-deep .van-sku-container {
    height: 100%;
    max-height: 100%;
  }
  ::v-deep .van-sku-stepper-stock {
    display: none;
  }
}
.lasted_num {
  margin-left: 12px;
}
</style>
